import { environment } from '../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {
  CuentasService,
  NegociosService,
  CUENTA_TYPE_CLIENTE,
  CUENTA_TYPE_PROSPECTO,
  CUENTA_TYPE_PROVEEDOR
} from '../../../services';
import { DialogsService } from '../../../services/dialogs-service';
import { NavigationService } from '../../../services/navigation-service';
import { GoogleMapsService } from '../../../services/google-maps-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ENTITY_TYPE_CUENTA } from '../../common/activity-list/activity-list.component';
import {
    PATH_CONTACTO_DETAIL,
    PATH_CUENTAS,
    PATH_NEGOCIOS,
    PATH_CUENTA_DETAIL
} from '../../../navigation/navigation.module';

import * as moment from 'moment';
import { ClienteSaldoListComponent } from '../../../components/common/cliente-saldo-list';
import { PermisosService, PERM_ACCIONES_ID } from '../../../services/permisos-service';

@Component({
  selector: 'app-cuenta-detail',
  templateUrl: './cuenta-detail.component.html',
  styleUrls: ['./cuenta-detail.component.scss']
})
export class CuentaDetailComponent implements OnInit, AfterViewInit {

  private cuenta;
  private cuentaId;
  private actividad = [];
  private cuentasAcopios;
  cuentaTypeProveedor = CUENTA_TYPE_PROVEEDOR;
  cuentaTypeCliente = CUENTA_TYPE_CLIENTE;
  cuentaTypeProspecto = CUENTA_TYPE_PROSPECTO;
  ENTITY_TYPE_CUENTA = ENTITY_TYPE_CUENTA;
  ASSETS_URL = environment.ASSETS_URL;

  private negociosMetricas: any = {};

  private selectedTabIndex: number = 0;

  private dataValid: boolean = true;
  private haveAccess: boolean = true;

  actividadPage: number = 0;
  lastActividadPage: number;
  lastActividadDate = 0;

  negociosExpanded = true;
  saldosExpanded = false;
  acopioSaldoSelected = null;

  private loadSaldosAutomatically = false;

  @ViewChild('map') mapElement: ElementRef;

  @ViewChild(ClienteSaldoListComponent) clienteSaldoComponent;

  // Use this flag to hide the map div in case geocoder didnt succeed. We CAN'T hide the div and then show it when geocoder
  // returns because this will glitch the map tiles. The map NEEDS the div width and height to be set when the page loads
  geoSuccess: boolean = true;
  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  constructor(private route: ActivatedRoute,
              private cuentasService: CuentasService,
              private negociosService: NegociosService,
              private location: Location,
              private dialogsService: DialogsService,
              private router: Router,
              private googleMapsService: GoogleMapsService,
              private navService: NavigationService,
              private permisosService: PermisosService)
  { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.cuentaId = this.route.snapshot.params['id'];
      const page = this.route.snapshot.params['page'];

      switch (page) {
        case 'info':
          this.selectedTabIndex = 0;
          break;
        case 'negocio':
          this.selectedTabIndex = 1;
          break;
      }

      this.checkAccess();
      this.loadData();
    });
  }

  ngAfterViewInit() {
    console.log(this.clienteSaldoComponent);
  }

  loadMap(){
    if (this.cuenta.Domicilio && this.cuenta.Domicilio.length > 0) {
      this.googleMapsService.loadMapWithLocation(
        this.mapElement.nativeElement,
        this.cuenta.Domicilio,
        this.cuenta.FullName,
        () => {
          this.geoSuccess = false;
        }
      );
    }
  }

  checkAccess() {
    this.cuentasService.checkUserAccess(this.cuentaId)
      .subscribe(value => {
        this.haveAccess = value.ResponseData;
      },
      err => this.dataValid = false
    );
  }

  loadData(){
    this.cuentasService.getCuenta(this.cuentaId)
        .subscribe(value => {
          this.cuenta = value;

          if (!this.cuenta) {
            this.dataValid = false;
            return;
          }

          this.cuentasAcopios = '';
          if (this.cuenta.CuentaAcopio) {
            this.cuenta.CuentaAcopio.forEach(x => {
              if (x.CuentaAcopio !== 0) {
                this.cuentasAcopios += + x.CuentaAcopio + ', ';
              }
            });
            if (this.cuentasAcopios.length >= 2) {
              this.cuentasAcopios = this.cuentasAcopios.slice(0, -2);
            }
          }

          this.geoSuccess = this.cuenta.Domicilio && this.cuenta.Domicilio.length > 0;
          // Give some extra time for mapElement to render
          setTimeout(() => this.loadMap(), 300);

          if (this.cuenta.Contacts && this.cuenta.Contacts.length) {
            this.cuenta.Contacts.sort((c1,c2) => c1.Principal ? -1 : (c2.Principal ? 1 : 0));
          }

          if (!this.cuenta.CuentaAcopioByUserRol || this.cuenta.CuentaAcopioByUserRol.length === 0) {
            // esperamos a que se inicialize el componente antes de acceder a el
            setTimeout(() => this.clienteSaldoComponent.noValuesToLoad(), 1000);
          }

          if (this.cuenta.CuentaAcopioByUserRol.length === 1) {
            this.acopioSaldoSelected = this.cuenta.CuentaAcopioByUserRol[0].Id;
            this.loadSaldosAutomatically = true;
          }
        }, err => this.dataValid = false);

    this.getActividad();

    /*this.cuentasService.getEstadisticasCuenta(this.cuentaId)
      .subscribe( data => {
        let { ResponseData } = data;
        this.estadisticasConsignas = ResponseData.ConsignasCantidad;
        this.estadisticasLogros = ResponseData.LogrosPorcentaje;
        this.estadisticasPuntos = ResponseData.Puntos;
      });*/

    this.negociosService.getMetricas(
        moment().set('year', 1990).startOf('year').toDate(),
        moment().add(18, 'months').toDate(),
        'Fecha',
        0,
        { cliente: [{Id: Number(this.cuentaId) }] },
        { Ordenes: true, Intenciones: true }
    ).subscribe(value => {
      if (value) {
        this.negociosMetricas = value;
      }
    });
  }

  getSaldo() {
    // vamos al servicio y llamamos
    this.clienteSaldoComponent.searchSaldo({cliente: this.cuenta.Id, acopio: this.acopioSaldoSelected});
  }

  selectTab(e) {
    const pages = ['/info', '/negocio']
    this.location.go(PATH_CUENTA_DETAIL+'/'+this.cuentaId+pages[e]);
  }

  getActividad() {
    // si se busca la misma pagina dos veces se replican los resultados, no buscar a menos que sean paginas distintas
    // la pagina a buscar cambia al llegar al fondo al hacer scroll, solo entonces refrescar actividades
    if (this.lastActividadPage !== this.actividadPage) {
      this.lastActividadPage = this.actividadPage;

      this.cuentasService.getActividad(this.cuentaId, this.actividadPage)
        .subscribe(value => {
          this.actividad = [...this.actividad, ...value.ResponseData];
          this.lastActividadDate = this.actividad.length ? this.actividad[0].FechaHora : 0;
        });
    }
  }

  editCuenta(cuenta){
    this.dialogsService.showNewCuentaDialog(this.cuenta, 'ACEPTAR', 'CANCELAR')
      .subscribe( (value:any) => {
        if (value) {
          this.loadData();
        }
      });
  }

  onDeleteCuenta(){
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta cuenta?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.cuentasService.deleteCuenta(this.cuenta.Id)
            .subscribe( data => {
              this.location.back();
            });
        }});
  }

  onActivateCuenta(){
    let activate = !this.cuenta.Habilitada;

    this.dialogsService.confirm(null,
                activate ? "¿Está seguro de que desea activar esta cuenta?" : "¿Está seguro de que desea desactivar esta cuenta?",
                activate ? "SÍ, ACTIVAR" : "SÍ, DESACTIVAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.cuentasService.activateCuenta(this.cuenta.Id)
            .subscribe( data => {
              if (data.ResponseData){
                this.location.back();
              }
            });
        }});
  }

  showNewContactoDialog(){
    this.dialogsService.showNewContactoDialog(
      this.cuenta.Id,
      null,
      'ACEPTAR',
      'CANCELAR'
    ).subscribe( () => {
      this.loadData();
    });
  }

  showNewNegocioDialog() {
    this.dialogsService.showNewNegocioDialog(null, false, {Id: this.cuenta.Id, FullName: this.cuenta.FullName});
  }

  navigateBack(){
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/'+PATH_CUENTAS+'/empresas');
    }
  }

  showNewConsignaDialog(){
    this.dialogsService.showNewConsignaDialog('Nueva Consigna', 'ACEPTAR', 'CANCELAR', 'MÁS OPCIONES', null, this.cuenta);
  }

  onAddLabel(){
    this.dialogsService.showNewEtiquetaDialog(this.cuenta).subscribe( () => {
      this.loadData();
    });
  }

  editContacto(contacto){
    this.dialogsService.showNewContactoDialog(
      'Editar Contacto',
      contacto,
      'GUARDAR',
      'CANCELAR'
    ).subscribe( () => {
      this.loadData();
    });
  }

  deleteContacto(contacto){
    this.dialogsService.confirm(null,
      "¿Está seguro de que desea eliminar este contacto?",
      "SÍ, ELIMINAR",
      "NO, CANCELAR")
        .subscribe( res => {
          if (res){
            this.cuentasService.deleteContacto(contacto.ClientContactId)
            .subscribe( data => {
              this.loadData();
            });
          }
        });
  }

  removeTag(tag) {
    this.dialogsService.confirm(null,
                "¿Está seguro de que desea eliminar esta etiqueta?",
                "SÍ, ELIMINAR",
                "NO, CANCELAR")
      .subscribe( res => {
        if (res){
          this.cuentasService.updateCuenta({
            ...this.cuenta,
            ...{
              Etiquetas: this.cuenta.Etiquetas.filter(e => e.Id !== tag.Id)
            }
          })
            .subscribe(_ => {
              this.cuenta.Etiquetas = this.cuenta.Etiquetas.filter(e => e.Id !== tag.Id);
            });
        }});
  }

  onBottomReached(reached: boolean) {
    this.actividadPage++;
    this.getActividad();
  }

  onContactoSelected(contacto){
    this.router.navigate([PATH_CONTACTO_DETAIL, contacto.ClientContactId]);
  }

  toggleNegocioContent(name) {
    if (name === 'saldo') {
      this.saldosExpanded = !this.saldosExpanded;
    } else if (name === 'negocio') {
      this.negociosExpanded = !this.negociosExpanded;
    }
  }

  saldosInitialized() {
    if (this.loadSaldosAutomatically) {
      setTimeout(() => this.getSaldo(), 300);
    }
  }

  canEdit() {
    if (this.cuenta && this.cuenta.ClientTypeId === this.cuentaTypeCliente) {
      return this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_EditarEmpr);
    } else if (this.cuenta && this.cuenta.ClientTypeId === this.cuentaTypeProspecto) {
      return this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_EditarProsp);
    }
    return false;
  }

  permisoAutorizado(id) {
    return this.permisosService.permisoAutorizado(id);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/cuenta-detail/cuenta-detail.component.ts